/**
 * @prettier
 * @flow
 */
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { translate } from 'src/utils/translate/translate';

export function FormExpiryField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const classes = useStyles();

    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();

    return (
        <Controller
            as={TextField}
            name={`${name}.expiry`}
            label={label}
            placeholder={translate('MM/YY')}
            // helperText={errors[name]?.['expiry']?.message ?? helperText}
            rules={{
                required: {
                    value: rules?.required,
                    message: translate('Expiry is required'),
                },
                pattern: {
                    value: /(00|01|02|03|04|05|06|07|08|09|10|11|12)\d\d/,
                    message: translate('Expiry must be in format MM/YY'),
                },
            }}
            error={!!errors[name]?.['expiry']}
            value={value}
            onChange={onChange}
            InputProps={{
                inputComponent: NumberFormatCustom,
                ...InputProps,
            }}
            inputProps={{ autoComplete: 'cc-exp', maxlength: 5 }}
            InputLabelProps={{ shrink: placeholder ? true : undefined }}
            variant={variant}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            control={control}
            defaultValue={defaultValue}
            classes={{ root: classes.input }}
        />
    );
}

export function NumberFormatCustom(props: { inputRef: any, name: string, onChange: Function }) {
    const { inputRef, onChange, ...other } = props;

    return <NumberFormat {...other} getInputRef={inputRef} onValueChange={values => onChange(values.value)} isNumericString format='##/##' mask='' decimalScale={0} />;
}

const useStyles = makeStyles(theme => ({
    input: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderTopColor: 'white',
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            },
            '&:hover fieldset': {
                // borderTopColor: 'white',
            },
            '&.Mui-focused fieldset': {
                // borderTopColor: 'white',
            },
        },
    },
}));

type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
    |},
    InputProps?: any,
    defaultValue?: string,
|};
